import React, { useEffect, useState } from "react";
import {
  Form,
  Button,
  Table,
  Card,
  Container,
  Row,
  Col,
  Modal,
  Spinner,
  Pagination,
} from "react-bootstrap";
import "../../css/sweetMsg.css";
import AdminScreenHeader from "./adminScreenHeader";
import { BsPlus } from "react-icons/bs";
import { apiPost } from "../../service/admin/apiService";
import { showSuccess, showError } from "../../utils/toast";
import Loader from "../loader";
import { FaTrash, FaEdit } from "react-icons/fa";
import Swal from "sweetalert2";
import "../../css/admin/adminCreateClient.css";

const AdminCreateClient = () => {
  const [editingIndex, setEditingIndex] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const [clientList, setClientList] = useState([]);
  const [clientName, setClientName] = useState("");
  const [fileNo, setFileNo] = useState("");
  const [panNo, setPanNo] = useState("");
  const [tanNo, setTanNo] = useState("");
  const [contactPerson, setContactPerson] = useState("");
  const [contactPerson2, setContactPerson2] = useState("");
  const [mobile1, setMobile1] = useState("");
  const [mobile2, setMobile2] = useState("");
  const [email, setEmail] = useState("");
  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [pin, setPin] = useState("");
  const [ddoName, setDdoName] = useState("");
  const [ddoPan, setDdoPan] = useState("");
  const [ddoDob, setDdoDob] = useState("");
  const [authPerson, setAuthPerson] = useState("");
  const [gstNo, setGstNo] = useState("");
  const [accountantMobile, setAccountantMobile] = useState("");
  const [form24Q, setForm24Q] = useState(0);
  const [form26Q, setForm26Q] = useState(0);
  const [form27EQ, setForm27EQ] = useState(0);
  const [formGstr1, setFormGstr1] = useState(0);
  const [formGstr7, setFormGstr7] = useState(0);
  const [limit, setLimit] = useState(10);
  const [activePage, setActivePage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);
  const [clientId, setClientId] = useState(0);
  const [showGroupModal, setShowGroupModal] = useState(false);
  const [parentClientId, setParentClientId] = useState(null);
  const [selectedChildClients, setSelectedChildClients] = useState([]);
  const [saveGroupLoader, setSaveGroupLoader] = useState(false);
  const [grpClient, setGrpClient] = useState(0);
  const [govrClient, setGovrClient] = useState(0);
  const tk = localStorage.getItem("tk") || "";

  const filteredClient = clientList.filter((client) => {
    const fullName = `${client.na}`.toLowerCase();
    const term = searchTerm.toLowerCase();
    return (
      client.na.toLowerCase().includes(term) ||
      client.fn.toLowerCase().includes(term) ||
      client.pa.toLowerCase().includes(term) ||
      client.ta.toLowerCase().includes(term) ||
      fullName.includes(term)
    );
  });

  useEffect(() => {
    getClientList();
  }, []);

  useEffect(() => {
    const calculatedMaxPage = Math.ceil(filteredClient.length / limit) || 1;
    setMaxPage(calculatedMaxPage);
    if (activePage > calculatedMaxPage) setActivePage(1);
  }, [filteredClient, limit]);

  const getClientList = async () => {
    const payload = {
      action: "clientlist",
      to: tk,
      ci: "",
    };

    console.log("payload", payload, process.env.REACT_APP_API_URL);

    if (tk && tk !== "") {
      try {
        setShowLoader(true);
        const response = await apiPost(process.env.REACT_APP_API_URL, payload);
        console.log("clients", response);
        if (Number(response?.errordetails?.errorcode) > 0) {
          showError(response?.errordetails?.error);
        } else if (response?.responsedetails) {
          setClientList(response?.responsedetails || []);
          console.log("clients", response?.responsedetails);
          setTimeout(() => {
            setShowLoader(false);
          }, 3000);
        }
      } catch (err) {
        console.error("Error:", err);
        showError("Something went wrong");
      } finally {
        setShowLoader(false);
      }
    }
  };

  const handleEdit = (id) => {
    const clientToEdit = clientList.find((client) => client.id === id);
    console.log("client", clientList);
    if (clientToEdit) {
      setClientName(clientToEdit.na);
      setFileNo(clientToEdit.fn);
      setPanNo(clientToEdit.pa);
      setTanNo(clientToEdit.ta);
      setContactPerson(clientToEdit.cp);
      setContactPerson2(clientToEdit.cp2);
      setMobile1(clientToEdit.m1);
      setMobile2(clientToEdit.m2);
      setAddress1(clientToEdit.a1);
      setAddress2(clientToEdit.a2);
      setCity(clientToEdit.ci);
      setState(clientToEdit.st);
      setPin(clientToEdit.pi);
      setDdoName(clientToEdit.dn);
      setDdoPan(clientToEdit.dp);
      setDdoDob(clientToEdit.ddb);
      setAuthPerson(clientToEdit.ap);
      setGstNo(clientToEdit.gn);
      setAccountantMobile(clientToEdit.am);
      setEmail(clientToEdit.ge);
      setForm24Q(clientToEdit.i24);
      setForm26Q(clientToEdit.i26);
      setForm27EQ(clientToEdit.i27);
      setFormGstr1(clientToEdit.ig1);
      setFormGstr7(clientToEdit.ig7);
      setGrpClient(clientToEdit.igc);
      setGovrClient(clientToEdit.igoc);
      setClientId(id);
      const index = clientList.findIndex((client) => client.id === id);
      setEditingIndex(index);
      setShowModal(true);
    } else {
      showError("Client not found.");
    }
  };

  const deleteClient = async (clientId) => {
    if (clientId === 0) {
      showError("You have not selected any client to delete");
      return;
    }

    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      width: "320px",
      customClass: {
        popup: "custom-swal-popup",
        confirmButton: "btn btn-sm btn-danger",
        cancelButton: "btn btn-sm btn-secondary",
      },
    });

    if (result.isConfirmed) {
      try {
        const payload = {
          action: "clientdelete",
          to: tk,
          ci: clientId,
        };
        const response = await apiPost(process.env.REACT_APP_API_URL, payload);
        if (Number(response?.errordetails?.errorcode) > 0) {
          showError(response?.errordetails?.error);
        } else if (response?.responsedetails) {
          showSuccess("Client delete successfully!!!");
          getClientList();
        }
      } catch (err) {
        console.error("Error:", err);
        showError("Something went wrong");
      }
    }
  };

  const handleAdd = () => {
    setClientName("");
    setFileNo("");
    setPanNo("");
    setTanNo("");
    setContactPerson("");
    setContactPerson2("");
    setMobile1("");
    setMobile2("");
    setAddress1("");
    setAddress2("");
    setCity("");
    setState("");
    setPin("");
    setDdoName("");
    setDdoPan("");
    setDdoDob("");
    setAuthPerson("");
    setGstNo("");
    setAccountantMobile("");
    setEmail("");
    setForm24Q(0);
    setForm26Q(0);
    setForm27EQ(0);
    setFormGstr1(0);
    setFormGstr7(0);
    setClientId(0);
    setEditingIndex(null);
    setShowModal(true);
  };

  const manageClient = async (transType) => {
    if (loading) return;
    if (!validateFields()) return;

    const payload = {
      action: "clientaddedit",
      to: tk,
      cn: clientName,
      cp: contactPerson,
      cp2: contactPerson2,
      pa: panNo,
      fn: fileNo,
      ta: tanNo,
      a1: address1,
      a2: address2,
      ci: city,
      st: state,
      pi: pin,
      m1: mobile1,
      m2: mobile2,
      dn: ddoName,
      dp: ddoPan,
      ddb: ddoDob,
      ap: authPerson,
      gn: gstNo,
      am: accountantMobile,
      ge: email,
      i24: form24Q.toString(),
      i26: form26Q.toString(),
      i27: form27EQ.toString(),
      ig1: formGstr1.toString(),
      ig7: formGstr7.toString(),
      igc: grpClient.toString(),
      igoc: govrClient.toString(),
      ...(transType === "clientupdate" && { ei: clientId }),
    };

    console.log("payload", payload);

    if (tk && tk !== "") {
      try {
        setLoading(true);
        const response = await apiPost(process.env.REACT_APP_API_URL, payload);

        if (Number(response?.errordetails?.errorcode) > 0) {
          showError(response?.errordetails?.error);
        } else if (response?.responsedetails) {
          if (response?.responsedetails?.success === "yes") {
            if (transType === "clientupdate") {
              showSuccess("Selected client updated successfully!!!");
            } else {
              showSuccess("Client created successfully!!!");
            }

            setShowModal(false);
            getClientList();
          }
        }
        setTimeout(() => {
          setLoading(false);
        }, 2000);
      } catch (err) {
        console.error("Error:", err);
        showError("Something went wrong");
      } finally {
        setLoading(false);
      }
    }
  };

  const validateFields = () => {
    if (
      !clientName.trim() ||
      !fileNo.trim() ||
      !panNo.trim() ||
      ((form24Q === 1 ||
        form26Q === 1 ||
        form27EQ === 1 ||
        formGstr1 === 1 ||
        formGstr7 === 1) &&
        !tanNo.trim())
    ) {
      showError("Fields with red asterisk cannot be left blank.");
      return false;
    }

    return true;
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > maxPage) return;
    setActivePage(pageNumber);
  };

  const groupClients = async () => {
    if (parentClientId !== null && selectedChildClients.length > 0) {
      console.log("Parent Client ID:", parentClientId);
      console.log("Selected Child Client IDs:", selectedChildClients);

      setSaveGroupLoader(true);
      const payload = {
        action: "clientparentupdate",
        to: tk,
        ci: selectedChildClients,
        pi: parentClientId,
      };

      console.log("payloadClientUp", payload);

      if (tk && tk !== "") {
        try {
          const response = await apiPost(
            process.env.REACT_APP_API_URL,
            payload
          );
          console.log("clientparentupdateRESP", response);
          if (Number(response?.errordetails?.errorcode) > 0) {
            showError(response?.errordetails?.error);
            setSaveGroupLoader(false);
          } else if (response?.responsedetails) {
            //setTimeout(() => {
            setSaveGroupLoader(false);
            getClientList();
            //}, 3000);
          }
        } catch (err) {
          console.error("Error:", err);
          showError("Something went wrong");
          setSaveGroupLoader(false);
        }
      }

      setShowGroupModal(false);
    } else {
      console.log("No parenet or chiled selected");
    }
  };

  return (
    <>
      <Container className="mt-4 ">
        <div className="d-none d-md-block mt-3">
          <AdminScreenHeader
            title="📋 All Clients"
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            placeholder="Search clients..."
            showSearch={true}
          />

          <div style={{ maxHeight: "478px", overflowY: "auto" }}>
            <Table
              striped
              bordered
              hover
              responsive
              className="w-100 custom-table text-primary custom-table-form24"
            >
              <thead>
                <tr>
                  <th style={{ width: "5%" }}></th>
                  <th style={{ width: "10%" }}>Group Client</th>
                  <th style={{ width: "30%" }}>Client Name</th>
                  <th style={{ width: "15%" }}>File No.</th>
                  <th style={{ width: "15%" }}>Pan No.</th>
                  <th style={{ width: "15%" }}>Tan No.</th>
                  <th style={{ textAlign: "center", width: "5%" }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {filteredClient
                  .slice((activePage - 1) * limit, activePage * limit)
                  .map((client, index) => (
                    <tr key={index}>
                      <td style={{ textAlign: "center" }}>
                        <FaTrash
                          style={{
                            color: "#2c3e50",
                            fontSize: "0.80rem",
                            cursor: "pointer",
                          }}
                          onClick={() => deleteClient(client.id)}
                        />
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {/* <Button
                          variant="success"
                          style={{ fontSize: "13px" }}
                          onClick={() => {
                            // Find all clients whose parentId matches the selected client’s id
                            const preselected = clientList
                              .filter((c) => c.pid === client.id) // assuming your API returns parentId
                              .map((c) => c.id);
                            console.log("preselected", preselected, client.id);
                            setParentClientId(client.id);
                            setSelectedChildClients(preselected); // pre-check these
                            setShowGroupModal(true);
                          }}
                        >
                          Group
                        </Button> */}
                        {client.igc === 1 ? (
                          <Button
                            className="btn-group-success"
                            style={{ fontSize: "13px" }}
                            // disabled={clientList.some((c) => c.pid === client.id)} // disable if already has children
                            onClick={() => {
                              // Find all children of this parent
                              const preselected = clientList
                                .filter(
                                  (c) => String(c.pid) === String(client.id)
                                )
                                .map((c) => c.id);

                              setParentClientId(client.id);
                              setSelectedChildClients(preselected);
                              setShowGroupModal(true);
                            }}
                          >
                            Group
                          </Button>
                        ) : null}
                      </td>
                      <td>{client.na}</td>
                      <td>{client.fn}</td>
                      <td>{client.pa}</td>
                      <td>{client.ta}</td>
                      <td style={{ textAlign: "center" }}>
                        <Button
                          variant="link"
                          onClick={() => handleEdit(client.id)}
                        >
                          <FaEdit
                            style={{ cursor: "pointer", color: "#2c3e50" }}
                          />
                        </Button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </div>
          <Row className="mt-3 mb-3">
            <Col className="d-flex align-items-center justify-content-between">
              {/* Records per page */}
              <div className="d-flex align-items-center">
                <label
                  className="me-2 mb-0"
                  style={{ color: "#0d6efd", fontSize: "13px" }}
                >
                  Records per page:
                </label>
                <Form.Select
                  value={limit}
                  onChange={(e) => {
                    const value =
                      e.target.value === "All"
                        ? filteredClient.length
                        : parseInt(e.target.value);
                    setLimit(value);
                    setActivePage(1); // Reset to first page on limit change
                  }}
                  style={{ width: "100px" }}
                >
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                  <option value="100000">All</option>
                </Form.Select>
              </div>

              {/* Pagination */}
              <Pagination className="mb-0">
                <Pagination.First
                  onClick={() => handlePageChange(1)}
                  disabled={activePage === 1}
                />
                <Pagination.Prev
                  onClick={() => handlePageChange(activePage - 1)}
                  disabled={activePage === 1}
                />
                <Pagination.Item>
                  {`Page ${activePage} of ${maxPage}`}
                </Pagination.Item>
                <Pagination.Next
                  onClick={() => handlePageChange(activePage + 1)}
                  disabled={activePage >= maxPage}
                />
                <Pagination.Last
                  onClick={() => handlePageChange(maxPage)}
                  disabled={activePage >= maxPage}
                />
              </Pagination>

              <div>
                <Button
                  onClick={() => {
                    handleAdd();
                  }}
                >
                  <BsPlus style={{ color: "#2c3e50", fontSize: "1.5rem" }} />{" "}
                  Create Client
                </Button>
              </div>
            </Col>
          </Row>
        </div>

        {/* Mobile View */}
        <div className="d-md-none mobile-view-container">
          <AdminScreenHeader
            title="📋 All Clients"
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            placeholder="Search client..."
            showSearch={true}
          />
          <div className="scrollable-card-body">
            {clientList
              .filter((client) => {
                const term = searchTerm.toLowerCase();
                return (
                  client.na.toLowerCase().includes(term) ||
                  client.fn.toLowerCase().includes(term) ||
                  client.pa.toLowerCase().includes(term) ||
                  client.ta.toLowerCase().includes(term)
                );
              })
              .map((client, index) => (
                <Card key={index} className="mb-2">
                  <Card.Body className="card-body">
                    <Card.Title className="mb-1 card-title">
                      {client.na}
                    </Card.Title>
                    <hr
                      style={{ marginTop: "0.5rem", marginBottom: "0.5rem" }}
                    />
                    <Card.Subtitle className="card-subtitle">
                      File No: {client.fn}
                    </Card.Subtitle>
                    <Card.Subtitle className="card-subtitle">
                      Pan No: {client.pa}
                    </Card.Subtitle>
                    <Card.Subtitle className="card-subtitle">
                      Tan No: {client.ta}
                    </Card.Subtitle>
                    <hr
                      style={{ marginTop: "0.5rem", marginBottom: "0.5rem" }}
                    />
                    <div className="d-flex justify-content-between mt-3">
                      <Button
                        size="sm"
                        variant="light"
                        onClick={() => handleEdit(client.id)}
                      >
                        Edit
                      </Button>

                      <Button
                        size="sm"
                        variant="light"
                        onClick={() => deleteClient(client.id)}
                      >
                        <FaTrash
                          style={{
                            color: "#2c3e50",
                          }}
                        />
                      </Button>
                    </div>
                  </Card.Body>
                </Card>
              ))}
          </div>

          <div className="d-flex justify-content-end mt-3">
            <Button
              size="sm"
              onClick={() => {
                handleAdd();
              }}
            >
              <BsPlus
                style={{
                  color: "white",
                  fontSize: "1.5rem",
                  fontWeight: "bold",
                }}
              />
              Create Client
            </Button>
          </div>
        </div>

        {/* Modal for Create/Edit Client*/}
        <style>
          {`
            .custom-modal-dialog {
              max-width: 65vw !important;
              width: 65vw !important;
            }

            @media (max-width: 768px) {
              .custom-modal-dialog {
                max-width: 95vw !important;
                width: 95vw !important;
              }
            }
          `}
        </style>
        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          centered
          dialogClassName="custom-modal-dialog"
        >
          <Modal.Header className="custom-header" closeButton>
            <Modal.Title className="text-primary ">
              {editingIndex !== null ? "Edit Client" : "Create Client"}
            </Modal.Title>
          </Modal.Header>

          <Form>
            <div className="modal-scrollable-content">
              <Modal.Body>
                <Form.Group className="mb-3 text-primary ">
                  <Form.Label className="textbox-label">
                    Client Name<span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    className="w-100"
                    value={clientName}
                    onChange={(e) => setClientName(e.target.value)}
                    tabIndex={1}
                    required
                  />
                </Form.Group>

                <Row>
                  {[
                    {
                      value: fileNo,
                      set: setFileNo,
                      label: "File No",
                      tab: 2,
                    },
                    {
                      value: panNo,
                      set: setPanNo,
                      label: "Pan No",
                      tab: 3,
                    },
                    {
                      value: tanNo,
                      set: setTanNo,
                      label: "Tan No",
                      tab: 4,
                    },
                    {
                      value: contactPerson,
                      set: setContactPerson,
                      label: "Contact Person 1",
                      tab: 5,
                    },
                    {
                      value: mobile1,
                      set: setMobile1,
                      label: "Mobile 1",
                      tab: 6,
                    },
                    {
                      value: contactPerson2,
                      set: setContactPerson2,
                      label: "Contact Person 2",
                      tab: 7,
                    },
                    {
                      value: mobile2,
                      set: setMobile2,
                      label: "Mobile 2",
                      tab: 8,
                    },
                    {
                      value: email,
                      set: setEmail,
                      label: "Email",
                      tab: 9,
                    },
                    {
                      value: address1,
                      set: setAddress1,
                      label: "Address Line 1",
                      tab: 10,
                    },
                    {
                      value: address2,
                      set: setAddress2,
                      label: "Address Line 2",
                      tab: 11,
                    },
                    {
                      value: city,
                      set: setCity,
                      label: "City",
                      tab: 12,
                    },
                    {
                      value: state,
                      set: setState,
                      label: "State",
                      tab: 13,
                    },
                    {
                      value: pin,
                      set: setPin,
                      label: "Pin",
                      tab: 14,
                      isLastBeforeHr: true, // Trigger <hr /> after this
                    },
                    {
                      value: ddoName,
                      set: setDdoName,
                      label: "D.D.O Name",
                      tab: 15,
                    },
                    {
                      value: ddoPan,
                      set: setDdoPan,
                      label: "D.D.O Pan",
                      tab: 16,
                    },
                    {
                      value: ddoDob,
                      set: setDdoDob,
                      label: "D.D.O Dob.",
                      tab: 17,
                    },
                    {
                      value: authPerson,
                      set: setAuthPerson,
                      label: "Authorised Person & Father Name",
                      tab: 18,
                    },
                    {
                      value: gstNo,
                      set: setGstNo,
                      label: "GST No.",
                      tab: 19,
                    },
                    {
                      value: accountantMobile,
                      set: setAccountantMobile,
                      label: "Accountant Mobile No.",
                      tab: 20,
                    },
                    {
                      type: "separator",
                    },
                    {
                      type: "heading",
                      label: "Add Forms Permission to Client",
                    },
                    {
                      value: form24Q,
                      set: setForm24Q,
                      label: "Form 24Q",
                      type: "checkbox",
                      tab: 21,
                    },
                    {
                      value: form26Q,
                      set: setForm26Q,
                      label: "Form 26Q",
                      type: "checkbox",
                      tab: 22,
                    },
                    {
                      value: form27EQ,
                      set: setForm27EQ,
                      label: "Form 27EQ",
                      type: "checkbox",
                      tab: 23,
                    },
                    {
                      value: formGstr1,
                      set: setFormGstr1,
                      label: "Form GSTR-1",
                      type: "checkbox",
                      tab: 24,
                    },
                    {
                      value: formGstr7,
                      set: setFormGstr7,
                      label: "Form GSTR-7",
                      type: "checkbox",
                      tab: 25,
                    },
                    {
                      type: "separator",
                    },
                    {
                      value: grpClient,
                      set: setGrpClient,
                      label: "Group Client",
                      type: "checkbox",
                      tab: 25,
                    },
                    {
                      value: govrClient,
                      set: setGovrClient,
                      label: "Government Client",
                      type: "checkbox",
                      tab: 25,
                    },
                  ].map((field, idx) => (
                    <React.Fragment key={idx}>
                      {field.type === "separator" && (
                        <Col xs={12}>
                          <hr />
                        </Col>
                      )}

                      {field.type === "heading" && (
                        <Col xs={12}>
                          <h5 className="mt-3 mb-4  text-primary text-decoration-underline">
                            {field.label}
                          </h5>
                        </Col>
                      )}

                      {field.type !== "separator" &&
                        field.type !== "heading" && (
                          <Col md={4} className="mb-3">
                            <Form.Group>
                              {field.type === "checkbox" ? (
                                <Form.Check
                                  type="checkbox"
                                  label={field.label}
                                  checked={field.value === 1}
                                  onChange={(e) =>
                                    field.set(e.target.checked ? 1 : 0)
                                  }
                                  tabIndex={field.tab}
                                  className="text-primary"
                                />
                              ) : (
                                <>
                                  <Form.Label className="textbox-label">
                                    {[
                                      "Client Name",
                                      "Pan No",
                                      "File No",
                                      "Tan No",
                                    ].includes(field.label) ? (
                                      <>
                                        {field.label}{" "}
                                        <span style={{ color: "red" }}>*</span>
                                      </>
                                    ) : (
                                      field.label
                                    )}
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    value={field.value}
                                    onChange={(e) => field.set(e.target.value)}
                                    tabIndex={field.tab}
                                    className="w-100 text-primary"
                                  />
                                </>
                              )}
                            </Form.Group>
                          </Col>
                        )}

                      {field.isLastBeforeHr && (
                        <Col xs={12}>
                          <hr />
                        </Col>
                      )}
                    </React.Fragment>
                  ))}
                </Row>
              </Modal.Body>
            </div>
            <div className="text-center text-md-end mb-2">
              <Button
                style={{ width: "200px" }}
                className="me-md-3"
                variant="primary"
                onClick={() => {
                  manageClient(
                    editingIndex !== null ? "clientupdate" : "clientadd"
                  );
                }}
              >
                {loading ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2" />
                    <BsPlus style={{ color: "#2c3e50", fontSize: "1.5rem" }} />
                    {editingIndex !== null ? "Updating..." : "Adding..."}
                  </>
                ) : (
                  <>
                    <BsPlus style={{ color: "#2c3e50", fontSize: "1.5rem" }} />
                    {editingIndex !== null ? "Update" : "Add"}
                  </>
                )}
              </Button>
            </div>
          </Form>
        </Modal>
        {/* Group client modal */}
        <Modal
          show={showGroupModal}
          onHide={() => setShowGroupModal(false)}
          centered
          size="lg"
        >
          <Modal.Header className="custom-header" closeButton>
            <Modal.Title className="text-primary">Group Clients</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Table
              striped
              bordered
              hover
              responsive
              className="w-100 custom-table text-primary custom-table-form24"
            >
              <thead>
                <tr>
                  <th style={{ width: "5%" }}>#</th>
                  <th>Client Name</th>
                  <th>File No</th>
                  <th>Pan No</th>
                </tr>
              </thead>
              <tbody>
                {/* {clientList
                  .filter((c) => c.id !== parentClientId) // exclude parent client
                  .map((c, idx) => (
                    <tr key={c.id}>
                      <td>
                        <Form.Check
                          type="checkbox"
                          checked={selectedChildClients.includes(c.id)}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setSelectedChildClients([
                                ...selectedChildClients,
                                c.id,
                              ]);
                            } else {
                              setSelectedChildClients(
                                selectedChildClients.filter((id) => id !== c.id)
                              );
                            }
                          }}
                        />
                      </td>
                      <td>{c.na}</td>
                      <td>{c.fn}</td>
                      <td>{c.pa}</td>
                    </tr>
                  ))} */}
                {clientList
                  .filter((c) => {
                    // Exclude parent itself
                    if (c.id === parentClientId) return false;

                    // Exclude if this client already has children (acts as parent)
                    const isAlreadyParent = clientList.some(
                      (x) => String(x.pid) === String(c.id)
                    );

                    // Exclude if this client is already assigned as a child under another parent
                    const isChildOfAnother =
                      c.pid &&
                      String(c.pid) !== "0" &&
                      String(c.pid) !== "Rmo3QTZKaXRVdXJSbElUQjZpbHl6Zz09" &&
                      String(c.pid) !== String(parentClientId);

                    return !isAlreadyParent && !isChildOfAnother;
                  })
                  .map((c, idx) => (
                    <tr key={c.id}>
                      <td>
                        <Form.Check
                          type="checkbox"
                          checked={selectedChildClients.includes(c.id)}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setSelectedChildClients([
                                ...selectedChildClients,
                                c.id,
                              ]);
                            } else {
                              setSelectedChildClients(
                                selectedChildClients.filter((id) => id !== c.id)
                              );
                            }
                          }}
                        />
                      </td>
                      <td>{c.na}</td>
                      <td>{c.fn}</td>
                      <td>{c.pa}</td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="primary"
              onClick={() => {
                groupClients();
              }}
            >
              <BsPlus
                style={{
                  color: "#2c3e50",
                  fontSize: "1.5rem",
                  fontWeight: "bold",
                }}
              />

              {saveGroupLoader ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Saving Groups...
                </>
              ) : (
                "Group Client"
              )}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Group client modal end */}

        {showLoader ? <Loader show={showLoader} /> : null}
      </Container>
    </>
  );
};

export default AdminCreateClient;
